import { registerArchetype } from './index.js';
import { applyDamage, applyHeal, computeDamage, lowestHpEnemy, livingEnemies, enemySide, effectiveAtk, effectiveDef } from '../combat.js';
registerArchetype({
    id: 'lifesteal',
    apply: ({ state, source, params, rng }) => {
        const mult = params.multiplier ?? 1;
        const pct = params.lifestealPct ?? 0.3;
        const enemies = livingEnemies(state, source.side);
        if (enemies.length === 0)
            return;
        const target = lowestHpEnemy(state, source.side);
        const sourceRt = (source.side === 'A' ? state.sideA : state.sideB)[source.slot];
        const dmg = computeDamage(effectiveAtk(sourceRt) * mult, effectiveDef(target.runtime));
        const dealt = applyDamage(state, source, { side: enemySide(source.side), slot: target.slot }, dmg, false, rng);
        applyHeal(state, source, Math.floor(dealt * pct));
    }
});
